/** Canonical origin used in SEO tags, JSON-LD and sitemap-related URLs. */
export const SITE_ORIGIN = 'https://smileup.pe';

export function absoluteUrl(pathname = '/') {
  const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${SITE_ORIGIN}${p}`;
}
